export default __webpack_public_path__ + "static/media/books.b05d86f2.png";